import { Col, Label, CustomInput, FormFeedback, FormGroup } from "reactstrap"
import React, { useState, useMemo } from 'react'
import PropTypes from 'prop-types'

/******************************************************************************************************************************************************/
//Componente responsavel por configurar um customInput(Radio) do reactstrap de acordo com a necessidade de gerar formulario dinamicos para supervisor//
/****************************************************************************************************************************************************/

// Função auxiliar para converter valor para string
const converterParaString = (valor) => {
    if (valor === undefined || valor === null) {
        return undefined;
    }
    if (typeof valor === 'boolean') {
        return valor.toString();
    }
    return String(valor);
};

// Função para gerar ID único
const gerarIdUnico = () => `radio_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

const RadioForm2 = (props) => {
    // Gera um ID único para esta instância do componente (não muda durante a vida do componente)
    const instanceId = useMemo(() => gerarIdUnico(), []);

    // Inicializa o estado convertendo o valorPadrao para string
    const [checked, setChecked] = useState(() => converterParaString(props.valorPadrao));

    const onChange = (event) => {
        const novoValor = event.target.value;
        setChecked(novoValor);
        props.onChange(props.name, novoValor);
    };

    const changeClass = () => (isValid());

    const isValid = () => ((checked) && props.invalido);

    // Função para verificar se a opção está marcada
    const isChecked = (elemento) => {
        const valorChecked = converterParaString(checked);
        const valorElemento = converterParaString(elemento.value);
        return valorChecked === valorElemento;
    };

    // Usa o instanceId para criar um name único para este grupo de radios
    const radioGroupName = `${props.name}_${instanceId}`;

    return (
        <Col {...props.style.col} className="form-col">
            <FormGroup className="form-group">

                <Label className={props.style.labelClass}>
                    {props.label}
                </Label>

                <div className="d-flex">
                    {props.options.map((elemento, indice) => (
                        <CustomInput
                            type="radio"
                            key={`${radioGroupName}-${indice}`}
                            id={`${radioGroupName}-${indice}`}
                            name={radioGroupName}
                            label={elemento.label}
                            checked={isChecked(elemento)}
                            onChange={onChange}
                            disabled={props.disabled}
                            value={elemento.value}
                            className={`${indice === 0 ? "margin-radio" : "ml-5"} ${changeClass()}`}
                        />
                    ))}
                </div>
            </FormGroup>
        </Col>
    );
}

export default RadioForm2;

const colShape = {
    xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const styleShape = {
    labelClass: PropTypes.string,
    elementoClass: PropTypes.string,
    col: PropTypes.shape(colShape)

}

RadioForm2.defaultProps = {
    placeholder: "",
    style: {
        labelClass: "label-conteudoInferior",
        elementoClass: "select select-form",
        col: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
            xl: 12
        }

    }
};

RadioForm2.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    name: PropTypes.string.isRequired,
    valorInicial: PropTypes.string,// index da opçao padrao
    onChange: PropTypes.func.isRequired,
    style: PropTypes.shape(styleShape)
}
